import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import config from '../config/config.json';

/* eslint-disable max-len */

const propTypes = {
  isTermsOpen: PropTypes.bool.isRequired,
  toggleTerms: PropTypes.func.isRequired,
};

const Terms = ({ isTermsOpen, toggleTerms }) => {
  const classes = classNames(
    'terms-section',
    'section',
    { st__hidden: !isTermsOpen },
  );

  return (
    <div
      className={classes}
      id="terms"
    >
      <h2 className="h2 terms-title">
        AIRVIVE -ARVONNAN SÄÄNNÖT
      </h2>
      <h3 className="h3 terms-title">
        Järjestäjä
      </h3>

      <p className="terms-copy">
        RRH FINLAND OY, ÄYRITIE 16 01510 VANTAA, jäljempänä &quot;Järjestäjä&quot;, järjestää AIRVIVE -arvonnan, jäljempänä &quot;Arvonta&quot;.
      </p>

      <h3 className="h3 terms-title">
        Sääntöjen soveltaminen
      </h3>

      <p className="terms-copy">
        Näitä sääntöjä sovelletaan Järjestäjän Arvontaan osoitteessa kampanjat.is.fi/airvive
      </p>

      <h3 className="h3 terms-title">
        Osallistumisen ehdot
      </h3>

      <p className="terms-copy">
        Arvontaan voivat osallistua kaikki Suomessa pysyvästi asuvat henkilöt pois lukien Järjestäjän työntekijät.
      </p>

      <p className="terms-copy">
        Osallistumalla Arvontaan osallistuja myöntää Järjestäjälle kaikki oikeudet toimittamaansa aineistoon, edelleenluovutus- ja muunteluoikeus mukaan lukien. Osallistujalle jää Järjestäjästä riippumaton käyttöoikeus toimittamaansa aineistoon. Osallistuja vastaa siitä, että hänellä on oikeus myöntää edellä mainitut oikeudet Järjestäjälle, ja että hän on saanut suostumuksen aineiston lähettämiseen kaikilta aineistossa esiintyviltä henkilöiltä.
      </p>

      <p className="terms-copy">
        Osallistumalla Arvontaan osallistujat sitoutuvat noudattamaan näitä sääntöjä.
      </p>

      <h3 className="h3 terms-title">
        Henkilötietojen käsittely
      </h3>

      <p className="terms-copy">
        Arvontaan osallistuneet ja markkinointiluvan antaneet henkilöt merkitään Järjestäjän suoramarkkinointirekisteriin. Arvonnan yhteydessä kerättäviä henkilötietoja voidaan käyttää ja luovuttaa suoramarkkinointitarkoituksiin henkilötietolain mukaisesti. Osallistumisen yhteydessä annettuja puhelinnumeroa ja osoitetietoja käytetään myös voittajien tavoittamiseen ja mahdollisten palkintojen toimittamiseen. Arvontaan osallistuvat henkilöt hyväksyvät osallistuessaan, että he saattavat saada sähköpostitse tietoa liittyen Arvontaan.
      </p>

      <h3 className="h3 terms-title">
        Osallistuminen ja arvonta-aika
      </h3>

      <p className="terms-copy">
        Arvontaan voi osallistua 13.10.-23.11.2025 välisenä aikana. Osallistuminen tapahtuu täyttämällä kampanjat.is.fi/airvive -sivuilla olevassa lomakkeeseen siinä pyydetyt tiedot, ja vahvistamalla osallistuminen painamalla Osallistu-painiketta. Arvontaan voi osallistua vain internetissä. Epäselvästi tai vajavaisin tiedoin täytettyjä osallistumisia ei huomioida.
      </p>

      <h3 className="h3 terms-title">
        Palkinto ja voittajan valinta
      </h3>

      <p className="terms-copy">
        Arvonnan palkintona on 4 kpl Remingtonin AIRvive -tuotteita. Palkintoa ei siirtää toiselle eikä sitä voi muuttaa rahaksi. Palkintojen arvot ovat
        {' '}
      </p>

      <p className="terms-copy">
        Palkinnot arvotaan 24.11.2025 kaikkien arvontaan osallistuneiden kesken, jonka jälkeen voittajiin ollaan yhteydessä.
      </p>

      <h3 className="h3 terms-title">
        Palkintojen luovutus ja voittajan julkistus
      </h3>

      <p className="terms-copy">
        Järjestäjä ilmoittaa viipymättä arvonnan suorittamisen jälkeen arvontavoitoista voittajille sähköpostitse, puhelimitse tai postitse. Jos voittajaa ei tavoiteta hänen osallistumisensa yhteydessä antamien yhteystietojen kautta, arvotaan tilalle uusi voittaja.
      </p>

      <h3 className="h3 terms-title">
        Järjestäjän vastuunrajoitus
      </h3>
      <p className="terms-copy">
        Järjestäjän vastuu Arvontaan osallistumisesta rajoittuu näissä säännöissä mainittujen palkintojen määrään ja arvoon sekä palkintojen luovuttamiseen. Järjestäjä ei vastaa esimerkiksi mahdollisista tietoliikenneyhteyksiin liittyvistä ongelmista arvontaan osallistumisen yhteydessä taikka osallistumisesta, palkinnon lunastamisesta tai käyttämisestä aiheutuvista kustannuksista tai Järjestäjän vaikutusmahdollisuuksien ulkopuolella olevista tapahtumista, jotka saattavat vaikuttaa esimerkiksi palkinnon hyödyntämiseen.
      </p>

      <h3 className="h3 terms-title">
        Verotus
      </h3>
      <p className="terms-copy">
        Järjestäjä vastaa arpajaisverosta. Järjestäjä antaa tiedon palkinnoista ja palkinnonsaajan tarpeellisista henkilötiedoista veroviranomaisille voimassaolevien verosäännösten edellyttämän mukaisesti.
      </p>
      <p className="terms-copy">
        <a
          className="terms-link"
          href={config.CUSTOMER_PRIVACY_POLICY}
          rel="noreferrer noopener"
          target="_blank"
        >
          Tutustu Järjestäjän tietosuojalausekkeeseen
        </a>
      </p>
      <button
        className="button terms-button"
        onClick={toggleTerms}
        type="button"
      >
        Piilota säännöt
      </button>
    </div>
  );
};

Terms.propTypes = propTypes;

export default Terms;
